import * as v from 'valibot';
import Ajax from '../util/ajax';
import { hastaTransmitterSchema } from '../types/HastaTransmitter';
import { hastaTransmitterUpdated } from '../reducers/hastaTransmittersSlice';
export function saveHastaTransmitter(t, okCallback, errorCallback) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/hasta-transmitter/' + t.id;
        ajax.post(url, t, data => {
            const res = v.safeParse(hastaTransmitterSchema, data);
            if (res.success) {
                dispatch(hastaTransmitterUpdated(res.output));
                okCallback();
            }
            else {
                console.error(v.summarize(res.issues));
                if (errorCallback != undefined) {
                    errorCallback();
                }
            }
        });
    };
}
